export const SETTINGS_TYPE = 'DAILY_CDP_SYNC_CONFIGURATION';

export const DEFAULT_DAILY_CDP_SYNC_PROPERTIES = {
  daily_mailshake_sync: true,
  daily_nurturing_history_sync: true,
  daily_warehouse_sync: true,
  daily_attribution_sync: true,
  daily_attribution_calc_sync: true,
  daily_tasks_sync: true,
};

export type DailyCdpSyncFlagKey = keyof typeof DEFAULT_DAILY_CDP_SYNC_PROPERTIES;

export const DAILY_CDP_SYNC_FLAG_FIELDS: {
  key: DailyCdpSyncFlagKey;
  label: string;
}[] = [
  { key: 'daily_mailshake_sync', label: 'Daily Mailshake Sync' },
  {
    key: 'daily_nurturing_history_sync',
    label: 'Daily Nurturing History Sync',
  },
  { key: 'daily_warehouse_sync', label: 'Daily Warehouse Sync' },
  { key: 'daily_attribution_sync', label: 'Daily Attribution Sync' },
  {
    key: 'daily_attribution_calc_sync',
    label: 'Daily Attribution Calc Sync',
  },
  { key: 'daily_tasks_sync', label: 'Daily Tasks Sync' },
];
